module.exports = __webpack_public_path__ + "static/blog-footer-11074ec5a5813a9dfac2b17807c03bcd.png";